<template>
    <app-layout>
        <asset-details-header />

        <div class="items-top my-6 flex justify-between gap-2">
            <filter-bar v-model="queryParams" :config="filterBarConfig" class="w-full" />
            <export-menu
                v-if="hasAnyPermission('activity.export')"
                :active-query-params="queryParams"
                :allowed-exports="['csv', 'xlsx']"
                :export-group-key="`activities-${asset.id}-export`"
                :no-item-selected-tooltip="trans('activities.overview.export.tooltip.no_item_selected')"
                :non-query-filters="{ assetId: asset.id }"
                :selection="selection"
                routeName="activities.export"
            />
        </div>

        <div class="py-3">
            <activity-log :activities="activities" :fields="fields" :query-params="queryParams" context="asset" />
        </div>
    </app-layout>
</template>
<script setup>
import AppLayout from '@/Layouts/AppLayout.vue';
import AssetDetailsHeader from '@/Pages/Assets/Details/AssetDetailsHeader.vue';
import ActivityLog from '@/Components/ActivityLog/ActivityLog.vue';
import FilterBar from '@/Components/FilterBar.vue';
import { usePage } from '@inertiajs/vue3';
import { useRoute } from 'ziggy-js';
import ExportMenu from '@/Components/ExportMenu.vue';
import useSelectedItems from '@/Utils/UseSelectedItems';
import { hasAnyPermission } from '@/mixins/hasAnyPermission.js';
import { computed, ref } from 'vue';
import { trans } from '@/mixins/i18n.js';

const page = usePage();
const route = useRoute();

const activitiesMeta = computed(() => page.props.activities?.meta || {});
const selection = useSelectedItems('asset-activities', activitiesMeta);

const queryParams = ref(null);
const usersOptions = computed(() =>
    (page.props.filters.users?.data || []).map(({ name, id }) => ({
        label: name,
        value: id,
    })),
);

const filterBarConfig = computed(() => ({
    route: route('assets.activities.index', page.props.asset),
    routeOptions: { only: ['activities'] },
    additionalData: () => ({ selection: selection.getSelectionAsQueryParams() }),
    onLoadSuccess: (data) => selection.setSelection(data.props.activities.meta.selection),
    defaultSort: { column: 'date', asc: false },
    filters: [
        { type: 'search', key: 'search', placeholder: trans('activities.overview.filter.placeholder') },
        { type: 'date-range', label: trans('activities.overview.cell.date'), startKey: 'start', endKey: 'end' },
        {
            type: 'multi-select',
            key: 'users',
            label: trans('activities.overview.cell.user'),
            options: usersOptions.value,
            showSearchbar: true,
        },
    ],
}));

const fields = [
    {
        key: 'date',
        label: trans('activities.overview.cell.date'),
        _style: 'width: 120px; min-width: 120px; max-width: 120px',
    },
    {
        key: 'causer',
        label: trans('activities.overview.cell.user'),
        _style: 'width: 200px; min-width: 200px; max-width: 200px',
    },
    {
        key: 'event',
        label: trans('activities.overview.cell.event'),
        sorter: false,
    },
];
const asset = computed(() => page.props.asset);
const activities = computed(() => page.props.activities);
</script>
